import { Keys } from './constants'
import ControlList from '../../utilities/Control/ControlList'
import { StoragePage, Kardex, FilterFormFields } from './types'
import ControlTabs from '../../utilities/ControlTabs'
import ControlRequest from '../../utilities/ControlRequest'
import FormEvents from '../../utilities/FormEvents'
import moment from 'moment'

export const storagePage: StoragePage = {
    header: {
        total_balance: 0,
        total_quantity: 0,
        records: 0
    },
    currency: null,
    timezone: ''
}

export const controlList = new ControlList<Kardex>(Keys.MAIN, {
    path: '/v5.6/apis/kardex',
    theads: [
        '#',
        { value: 'number', label: 'Número' },
        'Transacción',
        { value: 'date', label: 'Fecha' },
        'Bodega',
        { value: 'type', label: 'Tipo' },
        'Entrada',
        'Salida',
        'Saldo',
        'Valor de ingreso unitario',
        'Costo ponderado unitario',
        'Debe',
        'Haber',
        'Saldo'
    ]
})

controlList.filter.changeParams('sort', 'date')
controlList.filter.changeParams('order', 'desc')
controlList.badgeRemove('company_id', false)
controlList.badgeRemove('product_id', false)
controlList.badgeRemove('start_date', false)
controlList.badgeRemove('end_date', false)
controlList.badgeRemove('stowage_id', true)
controlList.badgeRemove('minimal_stowage_id', true)

export const reqSubStowage = new ControlRequest()

export const filterForm = new FormEvents<FilterFormFields>(Keys.FILTER_FORM, {
    start_date: moment('2020-01-01').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    stowage_id: null,
    minimal_stowage_id: null
})

controlList.onDeleteBadge = key => {
    if (key === 'stowage_id') {
        controlList.filter.deleteFilter('minimal_stowage_id')
        filterForm.setValue('minimal_stowage_id', null)
    }
}

export const ctsModalReception = new ControlTabs()
